import React from 'react';
import cssClasses from './DigitalCostSheetViewer.module.css';
import DropDown from '../../Subcomponents/DropDown';
import CustomInput from '../../Subcomponents/CustomInput';
import { getProjectList, getWingList } from '../../Services/Payments';
import { useState } from 'react';
import { useEffect } from 'react';
import { dismissLoader, presentLoader } from '../../Services/loader';
import {
  getProjectByProjectId,
  getUnitDataByProjectId,
} from '../../Services/Project';
import { errorTost } from '../../Services/Toast';
import { getProjectInventory } from '../../Services/Inventory';
import { debounce, uniqBy } from 'lodash';
import EmptyState from '../../Assets/Images/Common/noProjectFound.svg';
import sideMenuLogo from '../../Assets/Images/Common/costsheet.png';
import { useParams } from 'react-router-dom';
import { loginWithEmailPass } from '../../Services/LoginService';

const helperText = {
  fontSize: '1.4rem !important',
  margin: '0rem 0 0 0 !important',
  fontFamily: 'Inter-Medium !important',
  lineHeight: '1.8rem !important',
  paddingTop: '0.5rem !important ',
  color: '#d32f2f',
};

const DigitalCostSheetViewer = () => {
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedWing, setSelectedWing] = useState(null);
  const [wingList, setWingList] = useState([]);
  const [conditionText, setConditionText] = useState('');
  const [unitNo, setUnitNo] = useState(null);
  const [unitData, setUnitData] = useState([]);
  const [BannerUrl, setBannerUrl] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const params = useParams();

  useEffect(() => {
    const fetchEvents = async () => {
      const data = await getProjectList();
      setProjectList(data);
    };
    const loginAuthUser = localStorage.getItem('user');
    if(loginAuthUser) {
      fetchEvents();
    } else {
      loginWithEmailPass(process.env.REACT_APP_BOOKINGMIS_EMAIL, process.env.REACT_APP_BOOKINGMIS_PASSWORD).then((resp) =>{
    fetchEvents();
      }).catch((e) =>{
          console.log("Error in login: ", e);
      })
    }  
  }, []);

  useEffect(() => {
    if (projectList?.length > 0) {
      const index = projectList?.findIndex(
        (val) => val?.id?.substring(2) === params?.projectId
      );
      setSelectedProject(projectList[index]);
      setUnitData([]);
      setSelectedWing(null);
      getProjectData(projectList[index]);
      fetchWings(projectList[index]);
    }
  }, [params, projectList]);

  useEffect(() => {
    if (unitNo !== null && selectedWing?.id) {
      fetchDataUnitNoWise();
    }
  }, [unitNo, selectedWing]);

  const fetchDataUnitNoWise = () => {
    presentLoader();
    getUnitDataByProjectId(
      selectedProject?.id.substring(2),
      selectedWing?.id,
      unitNo
    )
      .then((val) => {
        dismissLoader();
        setUnitData(val);
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  };

  const getProjectData = (val) => {
    presentLoader();
    getProjectByProjectId(val?.id.substring(2))
      .then((val) => {
        console.log("val", val)
        if (val.data[0]?.bannerImages) {
          setBannerUrl(val.data[0]?.bannerImages)
          setIsDisabled(val?.data?.[0]?.isDigitalCostSheetDisable)
        } else {
          setBannerUrl(null)
        }

        dismissLoader();
        setConditionText(val?.data);
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  };

  const fetchWings = (val) => {
    presentLoader();
    getProjectInventory(val?.id.substring(2))
      .then((response44) => {
        dismissLoader();
        const Data = uniqBy(response44, 'wingId.wingId');
        const payload = [];
        Data.forEach((val) =>
          payload.push({
            id: val?.wingId?.wingId,
            label: val?.wingId?.displayName
              ? val?.wingId?.displayName
              : val?.wingId?.wingName,
          })
        );
        setWingList(payload);
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  const handleFetchUnitNo = (e) => {
    setUnitNo(e);
  };

  return (
    <div className={cssClasses.container}>
      <div className={cssClasses.header}>
        <img
          className={cssClasses.uploadedImg}
          id='eventBannerImg'
          src={
            BannerUrl
              ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
              BannerUrl +
              `?${Date.now()}`
              : ''
          }
          style={{ width: "40rem", borderRadius: "5px" }}
          alt=''
        />
        {/* <img
          src={sideMenuLogo}
          alt="logo"
          className={cssClasses.sideMenuLogo}
          style={{ width: "40rem",borderRadius:"5px" }}
        /> */}
        <label style={{ fontSize: '2rem', fontFamily: 'inter-semibold' }}>
          VJ Digital Cost-Sheet
        </label>
      </div>
      <div className={cssClasses.costContainer}>
        <div className={cssClasses?.costWrapper}>
          <div className={cssClasses.dropdown1}>
            <div className={cssClasses.label}>
              <p style={{ margin: '4px 0', fontSize: '1.6rem' }}>
                Project Name
              </p>
            </div>
            <div className={cssClasses.dropdownWrapper}>
              <DropDown
                onChangeSelect={(e) => {
                  setUnitData([]);
                  setSelectedWing(null);
                  setSelectedProject(e);
                  getProjectData(e);
                  fetchWings(e);
                }}
                selectedValue={selectedProject}
                style={{
                  minWidth: '120px',
                }}
                list={projectList}
              // disable={true}
              />
            </div>
          </div>
          <div className={cssClasses.dropdownWrapper1}>
            <div className={cssClasses.dropdown2}>
              <div className={cssClasses.label}>
                <p style={{ margin: '4px 0', fontSize: '1.6rem' }}>Wing Name</p>
              </div>
              <div className={cssClasses.dropdownWrapper}>
                <DropDown
                  onChangeSelect={(e) => {
                    setSelectedWing(e);
                  }}
                  selectedValue={selectedWing}
                  list={wingList}
                  disable={selectedProject === null || wingList?.length === 0}
                />
              </div>
            </div>
            <div className={cssClasses.inputFieldWrapper}>
              <div className={cssClasses.label}>
                <p style={{ margin: '4px 0', fontSize: '1.6rem' }}>
                  Enter Unit Number
                </p>
              </div>
              <div className={cssClasses.dropdownWrapper}>
                <CustomInput
                  disabled={selectedProject === null || selectedWing === null}
                  placeholder={'Enter Unit Number'}
                  handleChange={(e) => {
                    handleFetchUnitNo(e);
                  }}
                  inputType={'number'}
                  value={unitNo}
                />
              </div>
            </div>
          </div>
        </div>

        {(unitData?.length > 0 && !isDisabled) ? (
          <div className={cssClasses.dataContainer}>
            <div>
              <table className={cssClasses.customers}>
                <tr colSpan={2}>
                  <th>Details</th>
                  <th></th>
                </tr>
                <tr>
                  <td>Wing Name</td>
                  <td>{selectedWing?.label}</td>
                </tr>
                <tr>
                  <td>Unit No</td>
                  <td>{unitData?.length > 0 ? unitNo : '-'}</td>
                </tr>
                <tr>
                  <td>Unit Type</td>
                  <td>
                    {unitData[0]?.displayUnitType
                      ? unitData[0]?.displayUnitType
                      : unitData[0]?.inventoryTypeId?.type
                        ? unitData[0]?.inventoryTypeId?.type
                        : '-'}
                  </td>
                </tr>
                <tr>
                  {/* <td>Carpet Area (Sq.Ft.)</td> */}
                  <td>Saleable Area (Sq.Ft.)</td>
                  <td>
                    {unitData[0]?.saleableArea
                      ? unitData[0]?.saleableArea
                      : '-'}
                  </td>
                </tr>
                <tr>
                  <td>Price</td>
                  <td>
                    {unitData[0]?.totalCost
                      ? numDifferentiation(unitData[0]?.totalCost)
                      : '-'}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        ) : (
          <div style={{ height: '100%' }}>
            <p
              style={{
                //   position: "relative",
                //   top: "65%",
                //   transform: "translateY(-50%)",
                textAlign: 'center',
                fontSize: '3rem',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <img src={EmptyState} alt='No Data' />
                <span>No Data Available</span>
              </div>
            </p>
          </div>
        )}

        {(conditionText[0]?.digitalCostSheetTnc && unitData?.length > 0 && !isDisabled) && (
          <div style={{ marginTop: '2rem' }}>
            <label style={{ fontSize: '2rem', fontFamily: 'inter-semibold' }}>
              Terms & Conditions:
            </label>

            {conditionText[0]?.digitalCostSheetTnc ? (
              <div
                className={cssClasses.conditionUi}
                dangerouslySetInnerHTML={{
                  __html: conditionText[0]?.digitalCostSheetTnc?.includes('<p>')
                    ? conditionText[0]?.digitalCostSheetTnc
                    : convertStringToHTML(conditionText[0]?.digitalCostSheetTnc)
                      .outerHTML,
                }}
              />
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const convertStringToHTML = (htmlString) => {
  var doc = new DOMParser().parseFromString(htmlString, 'text/xml');
  var dom = document.createElement('ui');
  dom.innerHTML = doc.firstChild.innerHTML;
  return dom;
};

function numDifferentiation(value) {
  const val = Math.abs(value);
  // if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Crore`;
  if (val >= 100000) return `${(value / 100000).toFixed(2)} Lakh`;
  return value;
}

export default DigitalCostSheetViewer;
